module.exports = require('./lib/immutable')



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/immutable.js
// module id = 255
// module chunks = 31